module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAQCAYAAADAvYV+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACiSURBVHgBfZKBDYQgEATJN/CWQCmU8J28Hfx3oB1YgiVQgiVYgnaAuwma87JCsoELs8dxEIIYpZQJSnUdoRXqFPjlpoln6K9AZtk4K6OHeVyvjB78sVZl9GCqm1EZfZ0EP8ro4em8rTGmIMYLYv/eNd5Da7DZNpspo3sy3ADMIx+jdcINwHqRrVOAuWx8gqPrdw/lVnYCi4kzNLQM2TzS9UUPqJv+9Hn5Ay8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/left-arrow.png
// module id = h47J
// module chunks = 1